import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { DialogButtonConfig } from '@shared/ui';
import { ButtonDirective } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Ripple } from 'primeng/ripple';

@Component({
  selector: 'ui-dialog-actions',
  standalone: true,
  imports: [ButtonDirective, Ripple],
  templateUrl: './dialog-actions.component.html',
  styleUrl: './dialog-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogActionsComponent {
  private readonly dialogRef = inject(DynamicDialogRef);

  public readonly buttonConfig = input.required<DialogButtonConfig[]>();
  public readonly data = input.required<unknown>();

  public readonly action = output<DialogButtonConfig>();

  protected handleClick(config: DialogButtonConfig): void {
    if (config.closeOnClick === false) {
      this.action.emit(config);
      return;
    }

    this.dialogRef.close(config.passData ? this.data() : undefined);
  }
}
